import { FunctionComponent, useEffect, useState } from 'react'
import { Location, Navigate, useLocation } from 'react-router-dom'
import FamiliesList from './list/familiesList'
import ParentProfile from './parentProfile/parentProfile'
import { useAuth } from '@/modules/context/AuthContext'
import ChildProfile from './childProfile/childProfile'

const Families: FunctionComponent = () => {
    const { user } = useAuth()

    const urlDaycare: Location = useLocation()
    const paramDaycare: URLSearchParams = new URLSearchParams(urlDaycare.search)

    const [parentId, setParentId] = useState<number | null>(
        paramDaycare.get('parent') === null ? null : Number(paramDaycare.get('parent'))
    )

    const [childId, setChildId] = useState<number | null>(
        paramDaycare.get('child') === null ? null : Number(paramDaycare.get('child'))
    )

    const [showRegular, setShowRegular] = useState<boolean>(paramDaycare.get('regular') === 'true')

    useEffect((): void => {
        setParentId(paramDaycare.get('parent') === null ? null : Number(paramDaycare.get('parent')))
        setChildId(paramDaycare.get('child') === null ? null : Number(paramDaycare.get('child')))
        setShowRegular(paramDaycare.get('regular') === 'true')
    }, [urlDaycare])

    return (parentId !== null || childId !== null) &&
        (user?.currentDaycareRights.canReadFamilies || user?.currentDaycareRights.canReadSuggestions) ? (
        <>
            {childId === null ? (
                parentId === null ? (
                    <Navigate to='/' replace />
                ) : (
                    <ParentProfile parentId={parentId} />
                )
            ) : (
                <ChildProfile childId={childId} showRegular={showRegular} />
            )}
        </>
    ) : user?.currentDaycareRights.canReadFamilies ? (
        <FamiliesList />
    ) : (
        <Navigate to='/' replace />
    )
}

export default Families
